<template>
  <v-container>
    <v-card>
      <e-letter-e-letter-table :employee-uid="employee.employee_uid" />
    </v-card>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      ELetterELetterTable: () => import('@/components/eLetter/ELetterTable'),
    },
    metaInfo () {
      return {
        title: 'Letter',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
